<script>
import { usePageStore } from '@voix/store/pageStore'

export default {
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    slice: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    }
  },
  computed: {
    currentPage() {
      const pageStore = usePageStore()
      return pageStore.currentPage
    },
    devise() {
      return Object.assign({}, { fields: this.fields, page: this.currentPage, slice: this.slice })
    },

  },
  mounted() {
    defineSlice({
      name: {
        label: 'Glue Olapic',
        group: 'Galleries',
        layouts: ['Atlantisbahamas'],
      },
      preview: 'SlicesGlueGalleriesOlapic.jpg',
      description: 'Olapic Slider',
      tags: ['Gallery'],
      fields: { title: { label: 'Title', type: 'text', default: '"World of Atlantis"' }, stream: { label: 'Stream ID', type: 'text' } },
      templates: [{ label: 'Olapic', fields: [] }],
    })
  },
}
</script>

<template>
  <div class="pt-24 text-center text-zinc-700 bg-orange-100">
    <div class="flex flex-col items-center">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5_6120)">
          <path
            d="M9.37356 0.1119C7.67114 0.19222 6.50857 0.4639 5.49224 0.86326C4.44039 1.27318 3.54886 1.82326 2.66181 2.7135C1.77476 3.60374 1.22852 4.4959 0.821474 5.54934C0.42755 6.5679 0.160668 7.73142 0.0854668 9.43478C0.0102661 11.1381 -0.00637412 11.6857 0.00194596 16.0306C0.010266 20.3756 0.0294662 20.9202 0.112027 22.6271C0.193308 24.3292 0.464031 25.4914 0.863394 26.5081C1.27396 27.5599 1.8234 28.4511 2.71397 29.3385C3.60454 30.2258 4.49607 30.7708 5.55208 31.1785C6.56969 31.5717 7.73354 31.8399 9.4366 31.9145C11.1397 31.989 11.6878 32.0063 16.0315 31.998C20.3753 31.9897 20.9222 31.9705 22.6287 31.8895C24.3353 31.8085 25.4915 31.5359 26.5084 31.1385C27.5603 30.7269 28.4521 30.1785 29.3389 29.2876C30.2256 28.3967 30.7715 27.5039 31.1783 26.4498C31.5725 25.4322 31.8403 24.2684 31.9143 22.5666C31.9888 20.8588 32.0064 20.3135 31.9981 15.9692C31.9898 11.6249 31.9703 11.0802 31.8893 9.37398C31.8083 7.66774 31.5373 6.50902 31.1383 5.49174C30.7271 4.4399 30.1782 3.54934 29.288 2.66134C28.3977 1.77334 27.5043 1.22774 26.4505 0.82198C25.4323 0.42806 24.2691 0.15958 22.566 0.0859802C20.863 0.0123802 20.3148 -0.00649982 15.9695 0.00182018C11.6241 0.0101402 11.0801 0.0287002 9.37356 0.1119ZM9.56044 29.0361C8.00043 28.9682 7.15338 28.709 6.58889 28.4921C5.84136 28.2041 5.30888 27.8559 4.74631 27.2988C4.18375 26.7417 3.83814 26.2073 3.5463 25.4613C3.3271 24.8969 3.0631 24.0508 2.99014 22.4908C2.91077 20.8047 2.89413 20.2985 2.88485 16.0268C2.87557 11.7551 2.89189 11.2495 2.96582 9.56278C3.03238 8.00406 3.29318 7.15606 3.50982 6.5919C3.79782 5.84342 4.14471 5.3119 4.70311 4.74966C5.26152 4.18742 5.79432 3.84118 6.54089 3.54934C7.10474 3.32918 7.95083 3.06742 9.5102 2.99318C11.1976 2.91318 11.7032 2.89718 15.9743 2.8879C20.2453 2.87862 20.7522 2.89462 22.4402 2.96886C23.999 3.0367 24.8473 3.29494 25.4108 3.51286C26.1587 3.80086 26.6909 4.14678 27.2531 4.70614C27.8153 5.2655 28.1619 5.79638 28.4537 6.54454C28.6742 7.10678 28.936 7.95254 29.0096 9.51286C29.0899 11.2002 29.1082 11.7061 29.1158 15.9769C29.1235 20.2476 29.1085 20.7548 29.0346 22.4409C28.9664 24.0009 28.7078 24.8482 28.4905 25.4133C28.2025 26.1605 27.8553 26.6933 27.2966 27.2553C26.7379 27.8172 26.2057 28.1634 25.4588 28.4553C24.8956 28.6751 24.0486 28.9375 22.4905 29.0117C20.8031 29.0911 20.2975 29.1077 16.0248 29.117C11.7521 29.1263 11.2481 29.109 9.56076 29.0361M22.6041 7.44854C22.606 8.50902 23.4668 9.36726 24.5273 9.36534C25.5878 9.36342 26.446 8.50262 26.4441 7.44214C26.4422 6.38166 25.5814 5.52342 24.5209 5.52534H24.5203C23.4601 5.52758 22.6022 6.38838 22.6041 7.44854ZM7.78474 16.0159C7.7937 20.5535 11.4789 24.2236 16.0155 24.2149C20.5522 24.2063 24.2249 20.5215 24.2163 15.9839C24.2076 11.4463 20.5215 7.77526 15.9842 7.78422C11.4469 7.79318 7.7761 11.4789 7.78474 16.0159ZM10.6667 16.0101C10.6609 13.0645 13.044 10.6719 15.9896 10.6661C18.9353 10.6604 21.3279 13.0434 21.3337 15.989C21.3394 18.9346 18.9564 21.3273 16.0107 21.333C13.0654 21.3391 10.6728 18.9567 10.6667 16.0114V16.0101Z"
            fill="#EB897C"
          />
        </g>
        <defs>
          <clipPath id="clip0_5_6120">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <div class="mt-4 opacity-70 uppercase text-2xl lg:text-3xl font-sans font-light lg:leading-[65px]">
        {{ fields.title.value }}
      </div>

      <ul class="px-8 text-red-300 grid grid-cols-2 lg:grid-cols-4 gap-y-4 gap-x-12 font-sans2 font-light">
        <li>#AtlantisBahamas</li>
        <li>#TakeMeAway</li>
        <li>#OnIslandTime</li>
        <li>#Travel</li>
      </ul>
    </div>
    <div
      class="mt-6 flex flex-col lg:flex-row justify-center items-center space-y-4 lg:space-y-0 lg:space-x-12 text-glueblue-600"
    >
      <div class="flex itemsv-center justify-center space-x-8">
        <a href="https://facebook.com/atlantisbahamas" target="_blank" class="text-red-300 ">
          <svg
            xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"
            />
          </svg></a>
        <a href="https://instagram.com/atlantisbahamas" target="_blank" class="text-red-300 ">
          <svg
            xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
            />
          </svg></a>
        <a href="https://twitter.com/atlantisbahamas" target="_blank" class="text-red-300 ">
          <svg
            xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"
            />
          </svg></a>
      </div>
    </div>
    <div class="overflow-hidden">
      <GlueSlidersOlapicSlider arrow-color="zinc" :devise="devise" />
    </div>
  </div>
</template>
